import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { ShieldCheck } from "lucide-react";
import { toast } from "sonner";
import { useAI } from "@/lib/ai";
import { LEGAL_LINKS } from "@/lib/legalLinks";

export const AIConsentModal = () => {
  const { enabled, consent, setConsent } = useAI();
  const [saving, setSaving] = useState(false);
  if (!enabled || consent !== null) return null;

  const decide = async (granted) => {
    setSaving(true);
    try {
      await setConsent(granted);
      toast.success(granted ? "AI assistance turned on" : "AI assistance stays off");
    } catch {
      toast.error("Could not save your choice. Please try again.");
    } finally { setSaving(false); }
  };

  return (
    <Dialog open onOpenChange={() => {}}>
      <DialogContent className="max-w-md [&>button]:hidden" data-testid="ai-consent-modal">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <ShieldCheck className="w-5 h-5 text-emerald-600" /> AI photo analysis
          </DialogTitle>
          <DialogDescription className="text-left text-sm text-zinc-600 pt-2" data-testid="ai-consent-text">
            FieldProIQ uses a third-party AI service to analyze photos and job details. Photos and job information are sent to generate results.
          </DialogDescription>
        </DialogHeader>
        <a href={LEGAL_LINKS.privacyUrl} target="_blank" rel="noreferrer" className="text-xs underline text-zinc-500"
           data-testid="ai-consent-privacy-link">Privacy Policy</a>
        <div className="flex gap-2 pt-2">
          <Button variant="outline" className="flex-1 h-11" disabled={saving} onClick={() => decide(false)}
                  data-testid="ai-consent-decline">Not now</Button>
          <Button className="flex-1 h-11 bg-zinc-900 hover:bg-zinc-800 text-white" disabled={saving}
                  onClick={() => decide(true)} data-testid="ai-consent-accept">Allow</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
